module.exports = __webpack_public_path__ + "assets/webgl/wp_all_the_same_color.jpg.efa797af.webp";